
import React,{useState} from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import { MdMilitaryTech } from "react-icons/md";
function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <p className='websitename'>
        <MdMilitaryTech className='websiteicon' />Harsh
      </p>
      <div className="menu" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={menuOpen ? "open" : ""}>
      <li>
              <Link to='/'>
                About
              </Link>
            </li>
            <li>
              <Link to='/projects'>
                Projects
              </Link>
            </li>
            <li>
              <Link to='/contact'>
                Contact
              </Link>
            </li>
      </ul>
    </nav>
  );
}

export default Header;
